import React from "react";
import InternalLink from "components/InternalLink";
import { Button, Link } from "mondrian-react";
export default function LinkDetailsIcons({ ...props }) {
  if (!props.links) return null;

  const iconsize = props.iconsize ? props.iconsize : "sm";

  return (
    <div className="cred-ProfileLinkDetails">
      {props.links.map(
        (
          {
            internal,
            icon,
            link,
            linkText,
            content,
            itemId,
            tabIndex,
            ...attributes
          },
          index
        ) => (
          <div
            key={itemId || index}
            className="cred-ProfileLinkGroup"
            onMouseOver={props.onMouseOver}
          >
            <span
              onMouseLeave={props.onMouseLeave}
              onMouseOver={props.onMouseOver}
              className={`mdn-Icon-${icon} mdn-Icon--${iconsize} cred-ProfileLinkIcon`}
              aria-hidden="true"
            ></span>
            <div>
              {internal ? (
                <InternalLink
                  {...attributes}
                  onMouseOver={props.onMouseOver}
                  className="cred-ProfileMenuLink"
                  link={link}
                  id={itemId}
                >
                  {linkText}
                </InternalLink>
              ) : link ? (
                <Link
                  {...attributes}
                  inline
                  onMouseOver={props.onMouseOver}
                  className="cred-ProfileMenuLink"
                  href={link}
                  rel="noopener noreferrer"
                  id={itemId}
                  tabIndex={tabIndex}
                >
                  {linkText}
                </Link>
              ) : (
                <Button
                  {...attributes}
                  className="cred-ProfileMenuLink"
                  id={itemId}
                  tabIndex={tabIndex}
                  type="button"
                >
                  {linkText}
                </Button>
              )}
              <p className="cred-ProfileLinkDescription">{content}</p>
            </div>
          </div>
        )
      )}
    </div>
  );
}
